import React, { useCallback, useEffect, useState } from "react";
import { Tabs, Typography, Badge, Card, Button, Space } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateRight } from "@fortawesome/free-solid-svg-icons";
import ErrorLogTab from "./error-log-tab";
import ClickLogTab from "./click-log-tab";
import AccessLogTab from "./access-log-tab";
import BlockedIpTab from "./blocked-ip-tab";
import logApi from "../../../api/log-api";

const { Title } = Typography;

// Trang admin xem log: Lỗi (ErrorLog) / Click (ClickLog) / Access (AccessLog).
// Stats được fetch 1 lần ở cấp trang → dùng cho badge tab + stat card từng tab.
function LogViewer() {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(false);
    // Giá trị lọc lấy từ DB (không hardcode) — fetch 1 lần cho cả 3 tab.
    const [options, setOptions] = useState(null);

    const fetchStats = useCallback(async () => {
        setLoading(true);
        try {
            const { data } = await logApi.getStats();
            setStats(data.data || null);
        } catch {
            // im lặng — stat card sẽ hiện 0; bảng vẫn hoạt động độc lập
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { fetchStats(); }, [fetchStats]);

    useEffect(() => {
        logApi.getFilterOptions()
            .then(({ data }) => setOptions(data.data || null))
            .catch(() => setOptions(null)); // ô lọc vẫn dùng được ở chế độ gõ tay
    }, []);

    // Badge đếm tổng trên nhãn tab.
    const label = (text, count) => (
        <Space size={6}>
            {text}
            <Badge count={count || 0} overflowCount={99999} showZero
                style={{ backgroundColor: "rgb(var(--surface-muted))", color: "#555" }} />
        </Space>
    );

    // Cards trong mỗi tab tự lấy stats theo filter (qua hook); cha chỉ cung cấp
    // onRefreshStats để cập nhật badge tổng (toàn cục) sau khi xoá.
    const tabProps = { onRefreshStats: fetchStats };

    return (
        <div style={{ padding: 16 }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
                <Title level={3} style={{ margin: 0 }}>Logs hệ thống</Title>
                <Button icon={<FontAwesomeIcon icon={faRotateRight} />} loading={loading} onClick={fetchStats}>
                    Làm mới số liệu
                </Button>
            </div>
            <Card bodyStyle={{ padding: 16 }}>
                <Tabs
                    defaultActiveKey="errors"
                    destroyInactiveTabPane
                    items={[
                        {
                            key: "errors",
                            label: label("Lỗi (ErrorLog)", stats?.errors?.total),
                            children: <ErrorLogTab {...tabProps} options={options?.errors} />,
                        },
                        {
                            key: "clicks",
                            label: label("Click (ClickLog)", stats?.clicks?.total),
                            children: <ClickLogTab {...tabProps} options={options?.clicks} />,
                        },
                        {
                            key: "access",
                            label: label("Access (AccessLog)", stats?.access?.total),
                            children: <AccessLogTab {...tabProps} options={options?.access} />,
                        },
                        {
                            // Soi log thấy IP lạ → chặn ngay ở tab này, không cần sửa code/nginx.
                            key: "blocked-ips",
                            label: "Chặn IP",
                            children: <BlockedIpTab />,
                        },
                    ]}
                />
            </Card>
        </div>
    );
}

export default LogViewer;
